import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 21 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4 9C4-.333 17-.333 17 9" stroke="#FFB50D" strokeWidth="3" strokeLinecap="round" /><rect width="21" height="19" rx="4" transform="matrix(-1 0 0 1 21 9)" fill="#FFB50D" /></svg>);